"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_FLIGHT_CHANGE_SUMMARY = void 0;
exports.GET_FLIGHT_CHANGE_SUMMARY = {
    USER_NOT_FOUND: {
        usecase: 'GET_FLIGHT_CHANGE_SUMMARY',
        type: 'USER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Usuário não encontrado.',
        },
    },
    USER_NOT_BELONG_TO_SESSION: {
        usecase: 'GET_FLIGHT_CHANGE_SUMMARY',
        type: 'USER_NOT_BELONG_TO_SESSION',
        messageLangMap: {
            'PT-BR': 'Não é possível trocar o usuário durante uma solicitação de alteração de voo.',
        },
    },
    SESSION_WITH_INCOMPLETE_DATA: {
        usecase: 'GET_FLIGHT_CHANGE_SUMMARY',
        type: 'SESSION_WITH_INCOMPLETE_DATA',
        messageLangMap: {
            'PT-BR': 'As informações dos passos anteriores não foram preenchidas ou salvas.',
        },
    },
    OFFER_NOT_FOUND: {
        usecase: 'GET_FLIGHT_CHANGE_SUMMARY',
        type: 'OFFER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'A oferta original não encontrada.',
        },
    },
    TRAVEL_NOT_FOUND: {
        usecase: 'GET_FLIGHT_CHANGE_SUMMARY',
        type: 'TRAVEL_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Viagem não encontrada.',
        },
    },
};
